import { gql } from '@apollo/client';

export const GET_QUALITATIVE_FACTOR_SELECTED_IT_APPS = gql`
  query GetQualitativeFactorsSelectedITApplications($data: [String!]!) {
    getQualitativeFactorsSelectedITApplications(data: $data) {
      itApplications {
        uuid
        application
        applicationType
        mappingComment
      }
      uuid
    }
  }
`;

export const GET_QUALITATIVE_FACTORS_DASHBOARD = gql`
  query GetQualitativeFactorsDashboard {
    getQualitativeFactorsDashboard {
      applicationsTagged
      description
      isDefault
      isDirty
      lastUpdated
      name
      supportedByITApplication
      uuid
    }
  }
`;

export const UPDATE_QUALITATIVE_FACTOR = gql`
  mutation UpdateQualitativeFactor($data: UpdateQualitativeFactorInput!) {
    updateQualitativeFactor(data: $data) {
      description
      name
      uuid
    }
  }
`;

export const SET_IT_APPLICATIONS_TO_QUALITATIVE_FACTORS = gql`
  mutation SetItApplicationsToQualitativeFactor(
    $data: QualitativeFactorsMappingInput!
  ) {
    setItApplicationsToQualitativeFactor(data: $data)
  }
`;

export const SET_QUALITATIVE_FACTOR_MAPPING_COMMENT = gql`
  mutation SetQualitativeFactorMappingComment(
    $data: QualitativeFactorsMappingCommentInput!
  ) {
    setQualitativeFactorMappingComment(data: $data)
  }
`;
